import { Injectable, Inject } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
//import { Observable, throwError, BehaviorSubject } from 'rxjs';
//import { catchError, retry, map, tap } from 'rxjs/operators';
//import { GridDataResult } from '@progress/kendo-angular-grid';
//import { State } from '@progress/kendo-data-query';
//import { toODataString } from '@progress/kendo-data-query';
//import { CustomerList } from '../components/customer-list/customer-list.component';
import {
    ActionType
    , APIResponse
    , Contact
    , Customer
    , CustomerAction
    , CustomerActionForm
    //, CustomerActionList
    , CustomerFinancials
    , CustomerInitiative
    , CustomerInitiativeMap
    //, CustomerListResult
    //, CustomerLogisticLane
    //, CustomerParentHistory
    , CustomerStatus
    , CustomerStatusChecklist
    , CustomerStatusChecklistMap
    , FollowUpGrid
    , FreightSpendRange
    , Industry
    , Opportunity
    , OpportunityQuestion
    , OpportunityQuestionCategory
    , OpportunityQuestionMap
    , OpportunitySalesCycleMap
    , RateIndex
    , SalesCycle
    , SalesCycleCheckList
    , SalesCycleCheckListMap
    , SearchCRMFollowUp
    , SearchCRMOpportunity
    , SearchCustomer
    , SearchCustomerCriteria
    , Vendor
    , VolumeRange
} from '../models/models';

const httpOptions = {
    headers: new HttpHeaders({
        'Content-Type': 'application/json'
    })
};

@Injectable()
export class CRMService {
    public leads: SearchCustomer[] = [];
    public accounts: SearchCustomer[] = [];
    public prospects: SearchCustomer[] = [];
    public followUps: SearchCRMFollowUp[] = [];
    public opportunities: SearchCRMOpportunity[] = [];

    constructor(private http: HttpClient, @Inject('BASE_URL') private baseUrl: string) {
    }

    public deleteCustomerChecklistMap(checklistMap: CustomerStatusChecklistMap) {
        return this.http.post<boolean>(this.baseUrl + 'api/Customer/DeleteCustomerStatusChecklistMap', checklistMap, httpOptions);
    }

    public deleteCustomerInitiativeMaps(customerId: number) {
        return this.http.post<boolean>(this.baseUrl + 'api/CustomerInitiative/DeleteCustomerInitiativeMaps', customerId, httpOptions);
    }

    public deleteSalesCycleChecklistMap(checklistMap: SalesCycleCheckListMap) {
        return this.http.post<boolean>(this.baseUrl + 'api/SalesCycle/DeleteSalesCycleChecklistMap', checklistMap, httpOptions);
    }

    public getActionTypes() {
        return this.http.get<ActionType[]>(this.baseUrl + 'api/CustomerAction/GetActionTypes');
    }

    public getActionTypeByID(actionTypeID: number) {
        return this.http.get<APIResponse>(this.baseUrl + 'api/CustomerAction/GetActionTypeByID/?actionTypeID=' + actionTypeID);
    }

    public saveActionType(actionType: ActionType) {
        return this.http.post<APIResponse>(this.baseUrl + 'api/CustomerAction/SaveActionType', actionType, httpOptions);
    }

    public getCustomerByCustomerCode(customerCode: string) {
        return this.http.get<Customer>(this.baseUrl + 'api/Customer/GetByCustomerCode/?customerCode=' + encodeURIComponent(customerCode));
    }

    public getCustomerById(id: number) {
        return this.http.get<Customer>(this.baseUrl + 'api/Customer/Get/?id=' + id);
    }

    public getCustomerByAddressCityStateZip(address: string, city: string, state: string, zip: string) {
        return this.http.get<Customer>(this.baseUrl + 'api/Customer/GetByAddressCityStateZip/?address=' + address + '&city=' + city + '&state=' + state + '&zip=' + zip);
    }

    public getAllSearchCustomerLookupByName(lookupType: string, lookupValue: string) {
        return this.http.get<APIResponse>(this.baseUrl + 'api/Customer/GetAllSearchCustomerLookupByName/?lookupType=' + lookupType + '&lookupValue=' + lookupValue);
    }

    public getAllSearchCustomerLookupByCode(lookupType: string, lookupValue: string) {
        return this.http.get<APIResponse>(this.baseUrl + 'api/Customer/GetAllSearchCustomerLookupByCode/?lookupType=' + lookupType + '&lookupValue=' + lookupValue);
    }

    public getCustomerTeamTypes() {
        return this.http.get<APIResponse>(this.baseUrl + 'api/Customer/GetCustomerTeamTypes/');
    }

    public getSearchCustomerTeamByCustomerTeamTypeID(customerTeamTypeID: number) {
        return this.http.get<APIResponse>(this.baseUrl + 'api/Customer/GetSearchCustomerTeamByCustomerTeamTypeID/?customerTeamTypeID=' + customerTeamTypeID);
    }

    public getSearchCustomerTeamByEmployeeID(employeeID: number) {
        return this.http.get<APIResponse>(this.baseUrl + 'api/Customer/GetSearchCustomerTeamByEmployeeID/?employeeID=' + employeeID);
    }

    public getSearchCustomerTeamByCustomerID(customerID: number) {
        return this.http.get<APIResponse>(this.baseUrl + 'api/Customer/GetSearchCustomerTeamByCustomerID/?customerID=' + customerID);
    }

    public getSearchCustomerTeamByCustomerTeamTypeAbbreviation(customerTeamTypeAbbreviation: string) {
        return this.http.get<APIResponse>(this.baseUrl + 'api/Customer/GetSearchCustomerTeamByCustomerTeamTypeAbbreviation/?customerTeamTypeAbbreviation=' + customerTeamTypeAbbreviation);
    }

    public getSearchCustomerTeamByCustomerTeamTypeDescription(customerTeamTypeDescription: string) {
        return this.http.get<APIResponse>(this.baseUrl + 'api/Customer/GetSearchCustomerTeamByCustomerTeamTypeDescription/?customerTeamTypeDescription=' + customerTeamTypeDescription);
    }

    public getSearchCustomerTeamEmployeeByCustomerTeamTypeDescription(customerTeamTypeDescription: string) {
        return this.http.get<APIResponse>(this.baseUrl + 'api/Customer/GetSearchCustomerTeamEmployeeByCustomerTeamTypeDescription/?customerTeamTypeDescription=' + customerTeamTypeDescription);
    }

    public saveCustomerTeamMap(customerID: number, customerTeamTypeID: number, employeeID: number, lastModifiedByEmployeeID: number) {
        return this.http.get<APIResponse>(this.baseUrl + 'api/Customer/SaveCustomerTeamMap/?customerID=' + customerID + '&customerTeamTypeID=' + customerTeamTypeID + '&employeeID=' + employeeID + '&lastModifiedByEmployeeID=' + lastModifiedByEmployeeID);
    }

    public saveCustomerTeamMapList(customerIDList: number[], customerTeamTypeID: number, employeeID: number, lastModifiedByEmployeeID: number) {
        return this.http.post<APIResponse>(this.baseUrl + 'api/Customer/SaveCustomerTeamMapList/?customerTeamTypeID=' + customerTeamTypeID + '&employeeID=' + employeeID + '&lastModifiedByEmployeeID=' + lastModifiedByEmployeeID, customerIDList, httpOptions);
    }

    public getChildCustomersByCustomerId(customerId: number) {
        return this.http.get<Customer[]>(this.baseUrl + 'api/Customer/GetChildCustomersByCustomerId/?customerId=' + customerId);
    }

    public getSearchCustomer() {
        return this.http.get<APIResponse>(this.baseUrl + 'api/Customer/GetSearchCustomer/');
    }

    public getSearchCustomerByID(customerID: number) {
        return this.http.get<APIResponse>(this.baseUrl + 'api/Customer/GetSearchCustomerByID/?customerID=' + customerID);
    }

    public getSearchCustomerByCustomerCode(customerCode: string) {
        return this.http.get<APIResponse>(this.baseUrl + 'api/Customer/GetSearchCustomerByCustomerCode/?customerCode=' + customerCode);
    }

    public getSearchCustomerLeads() {
        return this.http.get<APIResponse>(this.baseUrl + 'api/Customer/GetSearchCustomerLeads/');
    }

    public getSearchCustomerProspectsByEmployeeID(employeeID: number) {
        return this.http.get<APIResponse>(this.baseUrl + 'api/Customer/GetSearchCustomerProspectsByEmployeeID/?employeeID=' + employeeID);
    }

    public getSearchCustomerByRepTypeEmployeeID(repType: string, employeeID: number) {
        return this.http.get<APIResponse>(this.baseUrl + 'api/Customer/GetSearchCustomerByRepTypeEmployeeID/?repType=' + repType + '&employeeID=' + employeeID);
    }

    public getSearchCustomerByCriteria(searchCustomerCriteria: SearchCustomerCriteria) {
        return this.http.post<APIResponse>(this.baseUrl + 'api/Customer/GetSearchCustomerByCriteria', searchCustomerCriteria, httpOptions);
    }

    //public getCustomerList() {
    //    return this.http.get<CustomerListResult[]>(this.baseUrl + 'api/Customer/GetCustomerList/');
    //}

    //public getCustomerListByRepTypeEmployeeId(repType: string, employeeId: number) {
    //    return this.http.get<CustomerListResult[]>(this.baseUrl + 'api/Customer/GetCustomerListByRepTypeEmployeeId/?repType=' + repType + '&employeeId=' + employeeId);
    //}

    //public getCustomersByStatusRepTypeEmployeeId(customerStatusId: number, repType: string, employeeId: number) {
    //    return this.http.get<Customer[]>(this.baseUrl + 'api/Customer/GetCustomersByStatusRepTypeEmployeeId/?customerStatusId=' + customerStatusId + '&repType=' + repType + '&employeeId=' + employeeId);
    //}

    public getCustomerActionByid(id: number) {
        return this.http.get<CustomerAction>(this.baseUrl + 'api/CustomerAction/GetCustomerActionById/?id=' + id);
    }

    public getcustomerActionsByCustomerId(customerId: number) {
        return this.http.get<CustomerAction[]>(this.baseUrl + 'api/CustomerAction/GetCustomerActionsByCustomerId/?customerId=' + customerId);
    }

    public getCustomerActionsByCustomerCode(customerCode: string) {
        return this.http.get<CustomerAction[]>(this.baseUrl + 'api/CustomerAction/GetCustomerActionsByCustomerCode/?customerCode=' + encodeURIComponent(customerCode));
    }

    public getSearchCustomerActionByCustomerID(customerID: number) {
        return this.http.get<APIResponse>(this.baseUrl + 'api/CustomerAction/GetSearchCustomerActionByCustomerID/?customerID=' + customerID);
    }

    public getSearchCustomerActionByOpportunityID(opportunityID: number) {
        return this.http.get<APIResponse>(this.baseUrl + 'api/CustomerAction/GetSearchCustomerActionByOpportunityID/?opportunityID=' + opportunityID);
    }

    public getSearchCustomerActionByEmployeeTransactionDates(employeeID: number, beginDate: Date, endDate: Date) {
        var beginIso = beginDate.toISOString();
        var endIso = endDate.toISOString();
        return this.http.get<APIResponse>(this.baseUrl + 'api/CustomerAction/GetSearchCustomerActionByEmployeeTransactionDates/?employeeID=' + employeeID + '&beginDate=' + beginIso + '&endDate=' + endIso);
    }

    //public getCustomerActionsByEmployeeTransactionDates(employeeId: number, beginDate: Date, endDate: Date) {
    //    var beginIso = beginDate.toISOString();
    //    var endIso = endDate.toISOString();
    //    return this.http.get<CustomerActionList[]>(this.baseUrl + 'api/CustomerAction/GetCustomerActionsByEmployeeTransactionDates/?employeeId=' + employeeId + '&beginDate=' + beginIso + '&endDate=' + endIso);
    //}

    public getCustomerActionsByEmployeeIdEventDates(employeeId: number, beginDate: Date, endDate: Date) {
        var beginIso = beginDate.toISOString();
        var endIso = endDate.toISOString();
        return this.http.get<CustomerAction[]>(this.baseUrl + 'api/CustomerAction/GetCustomerActionsByEmployeeIdEventDates/?employeeId=' + employeeId + '&beginDate=' + beginIso + '&endDate=' + endIso);
    }

    public getCustomerActionsByOpportunityid(opportunityId: number) {
        return this.http.get<CustomerAction[]>(this.baseUrl + 'api/CustomerAction/GetCustomerActionsByOpportunityId/?opportunityId=' + opportunityId);
    }

    public getCustomerFinancialsByID(customerID: number) {
        return this.http.get<CustomerFinancials[]>(this.baseUrl + 'api/Customer/GetCustomerFinancialsByID/?customerID=' + customerID);
    }

    public getCustomerFinancialsByIDYear(customerID: number, year: number) {
        return this.http.get<CustomerFinancials>(this.baseUrl + 'api/Customer/GetCustomerFinancialsByIDYear/?customerId=' + customerID + '&year=' + year);
    }

    public getCustomerInitiatives() {
        return this.http.get<CustomerInitiative[]>(this.baseUrl + 'api/CustomerInitiative/GetCustomerInitiatives');
    }

    //public getCustomerLeads() {
    //    return this.http.get<CustomerListResult[]>(this.baseUrl + 'api/Customer/GetCustomerLeads');
    //}

    //public getCustomerLeadsByRepTypeEmployeeId(repType: string, employeeId: number) {
    //    return this.http.get<CustomerListResult[]>(this.baseUrl + 'api/Customer/GetCustomerLeadsByRepTypeEmployeeId/?repType=' + repType + '&employeeId=' + employeeId)
    //}

    //public getCustomerQuotes(quoteOrderId: number, customerId: number, beginDate: Date, endDate: Date) {
    //    return this.http.get<QuoteGrid[]>(this.baseUrl + 'api/QuoteOrderLine/GetCustomerQuotes/?quoteOrderId=' + quoteOrderId + '&customerId=' + customerId);
    //}

    public getCustomerStatuses() {
        return this.http.get<CustomerStatus[]>(this.baseUrl + 'api/Customer/GetCustomerStatuses');
    }

    public getCustomerStatusChecklists() {
        return this.http.get<CustomerStatusChecklist[]>(this.baseUrl + 'api/Customer/GetCustomerStatusChecklists');
    }

    public getCustomerStatusChecklistMapsByCustomerId(customerID: number) {
        return this.http.get<CustomerStatusChecklistMap[]>(this.baseUrl + 'api/Customer/GetCustomerStatusChecklistMapsByCustomerID/?customerID=' + customerID);
    }

    public getContactsByCustomerCode(customerCode: string) {
        return this.http.get<Contact[]>(this.baseUrl + 'api/Contact/GetContactsByCustomerCode/?customerCode=' + encodeURIComponent(customerCode));
    }

    public getSearchCRMFollowUpByEmployeeID(employeeID: number) {
        return this.http.get<APIResponse>(this.baseUrl + 'api/Customer/GetSearchCRMFollowUpByEmployeeID/?employeeID=' + employeeID);
    }

    public getDashboardFollowUps() {
        return this.http.get<FollowUpGrid[]>(this.baseUrl + 'api/Customer/GetFollowUps');
    }

    //public getDashboardProspects(employeeId: number) {
    //    return this.http.get<CustomerListResult[]>(this.baseUrl + 'api/Customer/GetProspectsByEmployeeId/?employeeId=' + employeeId);
    //}

    public getSearchCRMOpportunityByEmployeeID(employeeID: number) {
        return this.http.get<APIResponse>(this.baseUrl + 'api/Opportunity/GetSearchCRMOpportunityByEmployeeID/?employeeID=' + employeeID);
    }

    //public getDashboardOpportunities(employeeId: number) {
    //    return this.http.get<OpportunityCard[]>(this.baseUrl + 'api/Opportunity/GetDashboardOpportunitiesByEmployeeID/?employeeID=' + employeeId);
    //}

    public getFreightSpendRanges() {
        return this.http.get<FreightSpendRange[]>(this.baseUrl + 'api/RateIndex/GetFreightSpendRanges');
    }

    public getHistoryByCustomerId(customerId: number, includeParent: boolean) {
        return this.http.get<APIResponse>(this.baseUrl + 'api/Customer/GetCustomerHistoryByCustomerId/?customerId=' + customerId + '&includeParent=' + includeParent);
    }

    public getIndustries() {
        return this.http.get<Industry[]>(this.baseUrl + 'api/Customer/GetIndustries');
    }

    public getIndustryByID(industryID: number) {
        return this.http.get<APIResponse>(this.baseUrl + 'api/Customer/GetIndustryByID?industryID=' + industryID);
    }

    public saveIndustry(industry: Industry) {
        return this.http.post<APIResponse>(this.baseUrl + 'api/Customer/SaveIndustry', industry, httpOptions);
    }

    public getInitiativeMapsByCustomerId(customerId: number) {
        return this.http.get<CustomerInitiativeMap[]>(this.baseUrl + 'api/CustomerInitiative/GetCustomerInitiativeMapsByCustomerId/?customerId=' + customerId);
    }

    //public getLogisticLanesByCustomerId(customerId: number) {
    //    return this.http.get<CustomerLogisticLane[]>(this.baseUrl + 'api/CustomerLogisticLane/GetCustomerLogisticLanesByCustomerId/?customerId=' + customerId);
    //}

    public getOpportunitiesByCustomerId(customerId: number) {
        return this.http.get<Opportunity[]>(this.baseUrl + 'api/Opportunity/GetOpportunitiesByCustomerId/?customerId=' + customerId);
    }

    public getOpportunitiesByCustomerIdProductId(customerId: number, productId: number) {
        return this.http.get<Opportunity[]>(this.baseUrl + 'api/Opportunity/GetOpportunitiesByCustomerIdProductId/?customerId=' + customerId + '&productId=' + productId);
    }

    public getSearchOpportunityByID(opportunityID: number) {
        return this.http.get<APIResponse>(this.baseUrl + 'api/Opportunity/GetSearchOpportunityByID/?opportunityID=' + opportunityID);
    }

    public getSearchOpportunityByCustomerID(customerID: number) {
        return this.http.get<APIResponse>(this.baseUrl + 'api/Opportunity/GetSearchOpportunityByCustomerID/?customerID=' + customerID);
    }

    public getOpportunitiesGridByCustomerId(customerId: number) {
        return this.http.get<OpportunitySalesCycleMap[]>(this.baseUrl + 'api/Opportunity/GetOpportunitiesGridByCustomerId/?customerId=' + customerId);
    }

    public getSearchCustomerOpportunityByCustomerID(customerID: number) {
        return this.http.get<APIResponse>(this.baseUrl + 'api/Opportunity/GetSearchCustomerOpportunityByCustomerID/?customerID=' + customerID);
    }

    public getOpportunityById(id: number) {
        return this.http.get<Opportunity>(this.baseUrl + 'api/Opportunity/GetOpportunityById/?id=' + id);
    }

    public getOpportunityQuestionCategories() {
        return this.http.get<APIResponse>(this.baseUrl + 'api/Opportunity/GetOpportunityQuestionCategories/');
    }

    public getOpportunityQuestionCategoryByID(opportunityQuestionCategoryID: number) {
        return this.http.get<APIResponse>(this.baseUrl + 'api/Opportunity/GetOpportunityQuestionCategoryByID/?opportunityQuestionCategoryID=' + opportunityQuestionCategoryID);
    }

    public saveOpportunityQuestionCategory(opportunityQuestionCategory: OpportunityQuestionCategory) {
        return this.http.post<APIResponse>(this.baseUrl + 'api/Opportunity/SaveOpportunityQuestionCategory', opportunityQuestionCategory, httpOptions);
    }

    public getOpportunityQuestions() {
        return this.http.get<APIResponse>(this.baseUrl + 'api/Opportunity/GetOpportunityQuestions/');
    }

    public getOpportunityQuestionByID(opportunityQuestionID: number) {
        return this.http.get<APIResponse>(this.baseUrl + 'api/Opportunity/GetOpportunityQuestionByID/?opportunityQuestionID=' + opportunityQuestionID);
    }

    public getOpportunityQuestionsByCategoryID(opportunityQuestionCategoryID: number) {
        return this.http.get<APIResponse>(this.baseUrl + 'api/Opportunity/GetOpportunityQuestionsByCategoryID/?opportunityQuestionCategoryID=' + opportunityQuestionCategoryID);
    }

    public saveOpportunityQuestion(opportunityQuestion: OpportunityQuestion) {
        return this.http.post<APIResponse>(this.baseUrl + 'api/Opportunity/SaveOpportunityQuestion', opportunityQuestion, httpOptions);
    }

    public getSearchOpportunityQuestion() {
        return this.http.get<APIResponse>(this.baseUrl + 'api/Opportunity/GetSearchOpportunityQuestion/');
    }

    public getSearchOpportunityQuestionMapByOpportunityID(opportunityID: number) {
        return this.http.get<APIResponse>(this.baseUrl + 'api/Opportunity/GetSearchOpportunityQuestionMapByOpportunityID/?opportunityID=' + opportunityID);
    }

    public saveOpportunityQuestionMap(opportunityQuestionMap: OpportunityQuestionMap) {
        return this.http.post<APIResponse>(this.baseUrl + 'api/Opportunity/SaveOpportunityQuestionMap', opportunityQuestionMap, httpOptions);
    }

    public getOpportunitySalesCylceMapById(id: number) {
        return this.http.get<OpportunitySalesCycleMap>(this.baseUrl + 'api/Opportunity/GetOpportunitySalesCycleMapById/?id=' + id);
    }

    public getRateIndices() {
        return this.http.get<RateIndex[]>(this.baseUrl + 'api/RateIndex/GetRateIndices');
    }

    public getSalesCycles() {
        return this.http.get<SalesCycle[]>(this.baseUrl + 'api/SalesCycle/GetSalesCycles');
    }

    public getSalesCycleCheckLists() {
        return this.http.get<SalesCycleCheckList[]>(this.baseUrl + 'api/SalesCycle/GetSalesCycleCheckLists');
    }

    public getSalesCycleCheckListMapsByOpportunityId(opportunityId: number) {
        return this.http.get<SalesCycleCheckListMap[]>(this.baseUrl + 'api/SalesCycle/GetSalesCycleCheckListMapsByOpportunityId/?opportunityId=' + opportunityId);
    }

    public getCurrentOpportunitySalesCycleMapByOpportunityID(opportunityID: number) {
        return this.http.get<APIResponse>(this.baseUrl + 'api/Opportunity/GetCurrentOpportunitySalesCycleMapByOpportunityID/?opportunityID=' + opportunityID);
    }


    public getSalesCycleCheckListMapByIds(checkListId: number, salesCycleId: number, opportunityId: number) {
        return this.http.get<SalesCycleCheckListMap>(this.baseUrl + 'api/SalesCycle/GetCheckListMapsByCheckListIdCycleIdOppId/?checkListId=' + checkListId + '&=cycleId=' + salesCycleId + '&=oppId' + opportunityId);
    }

    public getVendors() {
        return this.http.get<Vendor[]>(this.baseUrl + 'api/Vendor/GetVendors');
    }

    public getVolumeRanges() {
        return this.http.get<VolumeRange[]>(this.baseUrl + 'api/RateIndex/GetVolumeRanges');
    }

    public jumpOpportunitySalesCycle(opportunitySalesCycleMap: OpportunitySalesCycleMap) {
        return this.http.post<OpportunitySalesCycleMap>(this.baseUrl + 'api/Opportunity/JumpOpportunitySalesCycle', opportunitySalesCycleMap, httpOptions);
    }

    public saveCustomer(customer: Customer) {
        return this.http.post<Customer>(this.baseUrl + 'api/Customer/SaveCustomer', customer, httpOptions);
    }

    public saveCustomerComments(customerID: number, commentID: number, extraCommentID: number) {
        return this.http.get<APIResponse>(this.baseUrl + 'api/Customer/SaveCustomerComments/?customerID=' + customerID + "&commentID=" + commentID + "&extraCommentID=" + extraCommentID);
    }

    //public saveCustomerFromList(customer: CustomerListResult) {
    //    return this.http.post<Customer>(this.baseUrl + 'api/Customer/SaveCustomerFromList', customer, httpOptions);
    //}

    public saveCustomerAction(customerAction: CustomerAction) {
        return this.http.post<APIResponse>(this.baseUrl + 'api/CustomerAction/SaveCustomerAction', customerAction, httpOptions);
    }

    //public saveCustomerAction(customerAction: CustomerAction) {
    //    return this.http.post<CustomerAction>(this.baseUrl + 'api/CustomerAction/Save', customerAction, httpOptions);
    //}

    public saveCustomerActionForm(customerActionForm: CustomerActionForm) {
        return this.http.post<CustomerAction>(this.baseUrl + 'api/CustomerAction/Save', customerActionForm, httpOptions);
    }

    public saveCustomerInitiative(customerInitiative: CustomerInitiative) {
        return this.http.post<CustomerInitiative>(this.baseUrl + 'api/CustomerInitiative/SaveCustomerInitiative', customerInitiative, httpOptions);
    }

    public saveCustomerInitiativeMaps(customerInitiativeMaps: CustomerInitiativeMap[]) {
        return this.http.post<CustomerInitiativeMap[]>(this.baseUrl + 'api/CustomerInitiative/SaveCustomerInitiativeMaps', customerInitiativeMaps, httpOptions);
    }

    public saveCustomerStatusChecklistMap(checklistMap: CustomerStatusChecklistMap) {
        return this.http.post<CustomerStatusChecklistMap>(this.baseUrl + 'api/Customer/SaveCustomerStatusChecklistMap', checklistMap, httpOptions);
    }

    public jumpCustomerStatus(checklistMap: CustomerStatusChecklistMap, customerStatusID: number) {
        return this.http.post<APIResponse>(this.baseUrl + 'api/Customer/JumpCustomerStatus?customerStatusID=' + customerStatusID, checklistMap, httpOptions);
    }

    //public saveCustomerFromOrderEntry(customer: CustomerListResult) {
    //    return this.http.post<CustomerListResult>(this.baseUrl + 'api/Customer/SaveCustomerFromOrderEntry/', customer, httpOptions);
    //}

    //public saveCustomerLogisticLane(customerLogisticLane: CustomerLogisticLane) {
    //    return this.http.post<CustomerLogisticLane>(this.baseUrl + 'api/CustomerLogisticLane/SaveCustomerLogisticLane', customerLogisticLane, httpOptions);
    //}

    public saveOpportunity(opportunity: Opportunity) {
        return this.http.post<Opportunity>(this.baseUrl + 'api/Opportunity/SaveOpportunity', opportunity, httpOptions);
    }

    public saveOpportunitySalesCycle(oppSalesCycle: OpportunitySalesCycleMap) {
        return this.http.post<OpportunitySalesCycleMap>(this.baseUrl + 'api/Opportunity/SaveOpportunitySalesCycle', oppSalesCycle, httpOptions);
    }

    public saveSalesCycleCheckListMap(checkListMap: SalesCycleCheckListMap) {
        return this.http.post<SalesCycleCheckListMap>(this.baseUrl + 'api/SalesCycle/SaveSalesCycleCheckListMap', checkListMap, httpOptions);
    }

    public switchAssignedToReps(oldRepId: number, newRepId: number) {
        return this.http.post<boolean>(this.baseUrl + 'api/CustomerAction/SwitchAssignedToReps', { oldAssignedToId: oldRepId, newAssignedToId: newRepId }, httpOptions);
    }
}
